<template>
    <div class="wrapper">
        <div class="orderlist-order">
        <el-table
          :data="orderList"
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
            <el-table-column label="操作" align="center" width="240">
                        <template slot-scope="props">
                            <div style="text-align: left;margin: 10px 0">
                                <div style="color: #0062ff;" class="caozuo-btn" v-if="props.row.status ===0"
                                     @click="querenOrder(props.row.order_id)">设置已支付</div>
                                <div style="color: #ff6700;" class="caozuo-btn" v-else-if="(props.row.status ===2||props.row.status ===1)&&props.row.is_yuyue==0"
                                     @click="quxiaoOrder(props.row.order_id)">设置未支付</div>
                                <Confirm  :handleConfirm="()=>cancelOrder(props.row)" :loading="btnLoading" v-if="props.row.status===0">
                                <div style="background:#f3701e; color: white;border-radius: 3px;" class="caozuo-btn">取消订单</div>
                                </Confirm>
                                <Confirm  :handleConfirm="()=>deleteOrders(props.row.order_sn)" :loading="btnLoading" v-if="props.row.status===1">
                                    <div style="background:#f32d29; color: white;border-radius: 3px;" class="caozuo-btn">移除订单</div>
                                </Confirm>
                                <div  class="caozuo-btn">
                                    <a style="text-decoration:none;color: #0062ff"
                                       target="_blank"
                                       :href="$reqUrl + 'admin/order.php?act=info&order_id='+props.row.order_id+'&print='+1"
                                       class="points">打印合同</a>
                                </div>
                                <!--<div style="border: 1px solid #d15723;color: #d15723;" class="caozuo-btn" @click="changeContractNumber(props.row)" v-if="props.row.referer==='门店'||props.row.referer==='扫码'">修改合同订单号</div>-->
                                <!--<PayStyleDialog :order="props.row" :update="getOrderList" >-->
                                <!--<div style="border: 1px solid #ff7706;color: #ff7706;float: left" class="caozuo-btn" v-if="props.row.status === 0 ">修改支付方式</div>-->
                                <!--</PayStyleDialog>-->
                                <div style="color: #0062ff;" class="caozuo-btn" @click="OrderDetail(props.row)">订单详情</div>
                                <!--<div style="border: 1px solid #37c1e5;color: #37c1e5;" class="caozuo-btn" v-if="props.row.is_upload===1" @click="checkimg(props.row)">查看凭证</div>-->
                                <!--<div style="border: 1px solid #37c1e5;color: #37c1e5;" class="caozuo-btn" v-if="props.row.order_images!==''" @click="checkFujian(props.row)">查看附件</div>-->
                            </div>
                        </template>
            </el-table-column>
            <el-table-column label="下单日期" prop="order_time" align="center" sortable width="80">
                <template slot-scope="props">
                    <div>{{props.row.order_time|xiadanTime}}</div>
                    <div>{{props.row.order_time|xiadanTime2}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="xiadanname" label="订单来源" align="center"></el-table-column>
            <el-table-column label="合同订单号" prop="contract_number" align="center"></el-table-column>
            <el-table-column label="型号" align="center" width="115">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods_list" style="font-size: 10px;padding: 10px 0">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" align="center" width="50">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods_list" style="padding: 10px 0">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="单价" align="center" width="60">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods_list" style="padding: 10px 0">{{item.goods_price|price}}</div>
                </template>
            </el-table-column>
            <!--<el-table-column label="修改" align="center">-->
                <!--<el-table-column label="删除" align="center" width="50">-->
                    <!--<template slot-scope="props">-->
                        <!--<Confirm-->
                            <!--v-for="item in props.row.goods_list"-->
                            <!--:key="item.id"-->
                            <!--:handleConfirm="()=>deleteOrder(props.row.goods_list,item.rec_id)" :loading="btnLoading">-->
                        <!--<div  style="width: 100%;padding:5px 0;border: 1px solid red;color: white;margin: 10px 0;cursor: pointer"><el-button type="text" style="color: red;padding: 0;">删除</el-button></div>-->
                        <!--</Confirm>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column label="修改" align="center" width="50">-->
                    <!--<template slot-scope="props">-->
                        <!--<Dialogsa-->
                            <!--v-for="item in props.row.goods_list"-->
                            <!--:key="item.id"-->
                            <!--:goods_attr_list="item.goods_attr_list"-->
                            <!--:goods_attr_id="item.goods_attr_id"-->
                            <!--:goods_id="item.goods_id"-->
                            <!--:rec_id="item.rec_id"-->
                            <!--:product_id="item.product_id"-->
                            <!--:referer="props.row.referer"-->
                            <!--:goods_price="item.goods_price"-->
                            <!--:order_id="item.order_id"-->
                            <!--:goods_number="item.goods_number"-->
                            <!--:getCartProducts="getCartProducts"-->
                            <!--:getOrderList="getOrderList"-->
                        <!--&gt;-->
                            <!--<div style="width: 40px;padding:5px 0;border: 1px solid #ff7706;color: white;margin: 5px 0;cursor: pointer"><el-button type="text" style="color: #ff7706;padding: 0;">修改</el-button></div>-->
                        <!--</Dialogsa>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <!--<el-table-column label="添加" align="center" width="50">-->
                    <!--<template slot-scope="props">-->
                        <!--<div style="width: 100%;height:100%;padding:5px 0; border: 1px solid #1580ff;color: #1580ff;margin: 5px 0;cursor: pointer;"><span @click="addorder(props.row.order_id)">添加</span></div>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            <!--</el-table-column>-->
            <el-table-column label="实付" align="center" width="50">
                <template slot-scope="props">
                    <div style="padding: 10px 0">{{props.row.goods_amount|prices}}</div>
                </template>
            </el-table-column>
            <el-table-column label="客户姓名" prop="consignee" align="center" width="70"></el-table-column>
            <el-table-column label="客户电话" prop="mobile" align="center"></el-table-column>
            <!--<el-table-column label="备用电话" prop="tel" align="center"></el-table-column>-->
            <el-table-column label="客户地址" prop="address_detail" align="center" width="150"></el-table-column>
            <el-table-column label="备注" prop="postscript" align="center"></el-table-column>
            <el-table-column label="预约日期"  align="center" width="70">
                <template slot-scope="props">
                    {{props.row.install.yuyue_time?props.row.install.yuyue_time:''|formatter}}
                </template>
            </el-table-column>
            <el-table-column label="订单号" prop="order_sn" align="center"></el-table-column>
            <el-table-column label="支付方式" prop="payname" align="center" width="70"></el-table-column>
            <el-table-column label="订单状态" prop="" align="center" width="70">
                <template slot-scope="props">
                    <div >{{props.row.status==0?'待审核':props.row.status==1?'已关闭':props.row.status!==0&&props.row.install.type =='未分配'?'待发货':props.row.install.status=='0'||props.row.install.status=='1'?'已分配':props.row.install.status=='3'?'已安装':props.row.install.status=='4'?'已指派':'待发货'}}</div>
                </template>
            </el-table-column>
        </el-table>
        </div>
        <el-dialog title="查看凭证" :visible.sync="outerVisible" align="center" width="700">
            <a :href="host+item" target="_blank" v-for="item in order.payimg"><img :src="host+item"  style="width: 150px;display: inline-block;margin-left: 20px;cursor: pointer"></a>
            <div slot="footer" class="dialog-footer">
                <el-button @click="outerVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="查看附件" :visible.sync="showFujian" align="center" width="700">
            <a :href="host+'/data/paylogimg/'+item" target="_blank" v-for="item in order.order_images"><img :src="host+'data/paylogimg/'+item"  style="width: 150px;display: inline-block;margin-left: 20px;cursor: pointer"></a>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showFujian = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改合同订单号" :visible.sync="changeOrderNumber" width="500px">
            <el-form :model="changeForm" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="合同订单号:" :label-width="formLabelWidth">
                    <el-input v-model="changeForm.contract_number"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="ChangeConOrder" :loading="isbtnload">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        host,
        cancelOrder,
        getAppointment,
        deleteOrder,
        postAppointment,
        session_id,
        getCartProducts,
        getUserInfo,
        getAddressSelect,
        getInstallCompany,
        deleteOrders
    } from '../../stores/api';
    import PayStyleDialog from '../Common/PayStyleDialog.vue';
    import AddressDialog from '../Common/AddressDialog.vue';
    import Confirm from '../Common/Confirm.vue';
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import Dialogs from './Dialogs.vue';
    import ElRow from "element-ui/packages/row/src/row";
    import ElCol from "element-ui/packages/col/src/col";

    Vue.component('Dialogsa', Dialogs);
    Vue.component('PayStyleDialog', PayStyleDialog);
    Vue.component('AddressDialog', AddressDialog);
    Vue.component('Confirm', Confirm);
    export default {
        components: {
            ElCol,
            ElRow},
        props: ['orderList', 'getOrderList'],
        data() {
            return {
                outerVisible: false,
                showFujian: false,
                innerVisible: false,
                changeOrderNumber: false,
                rotate: 0,
                pzimg: '',
                value1: '',
                yytime: '',
                ordlist: [],
                ordlist1: [],
                changeForm: {contract_number: '', order_id: ''}, //修改合同订单号
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                host: host,
                cancelVisible: false,
                btnLoading: false,
                addressData: null,
                appointmentData: [],
                currAppointment: '',
                orderAuth: '',
                referer: '',
                Auth:{
                    payOrder:false,
                    addOrderGoods:false,
                    editPay:false,
                    lookOrder:false,
                    print:false,
                    cancelOrder:false,
                    editOrderGoods:false,
                    lirun:false
                },
                hrefs: '',
                delivery_method: '',
                orderlt: [],
                options: [{value: 0, label: '送货'},
                    {value: 1, label: '物流'},
                    {value: 2, label: '自提'},
                    {value: 3, label: '送装'},
                    {value: 4, label: '快递'},
                    {value: 5, label: '直发'},
                    {value: 6, label: '其他'}
                ],
                ShowDistribution: false,
                OrderFenpei: [],
                OrderSelect: [], //分配的订单数组
                formLabelWidth: '100px',
                form: {},
                changeAddress: false, //是否修改地址
                passSelect: [{value: 0, label: '送货'},
                    {value: 1, label: '物流'},
                    {value: 2, label: '自提'},
                    {value: 3, label: '送装'},
                    {value: 4, label: '快递'},
                    {value: 5, label: '直发'},
                    {value: 6, label: '其他'}
                ],
                formData: {//填写配送信息
                    goodsSelect: '', //配送方式
                    azTime: '',
                    yytime: '', //安装时间
                    company_id: '',
                    company_name: '',
                    siji_id: '',
                    siji_name: '',
                    wuliu_id: '',
                    wuliu_name: '',

                    province: '', //省
                    city: '', //市
                    district: '', //区
                    address: '', //详细地址
                },
                selectCompany: [],
                selectWuliu: [],
                selectSonghuo: [],
                page: 1,
                pickerOptions0: {//限制安装时间只能是当天或之后
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                order: '',
            };
        },
        filters: {
            formatter(time) {
                if (time !== '' && time !== '0') {
                    return new Date(Number(time)*1000).toLocaleDateString().replace(/\//g, "-")
                } else {
                    return '未预约'
                }
            },
            price(money) {
                return Number(money)
            },
            prices (val) {
                return Number(val.split('￥')[1].split('元')[0])
            },
            xiadanTime(val) {
                return val.split(" ")[0]
            },
            xiadanTime2(val) {
                return val.split(" ")[1]
            }
        },
        created() {
            this.getqx()

            // console.log('temp'+ JSON.stringify(this.temp));
            // this.getordList()
        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.formData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.formData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        },
        methods: {
            getordList () {
                this.ordlist = []
                this.ordlist1 = []
                this.order.goods_list.forEach(item => {
                    if (item.yuyue_number !== item.goods_number) {
                        this.ordlist.push(item.goods_name)
                    }
                })
                this.order.goods_list.forEach(item => {
                    if (item.yuyue_number !== item.goods_number) {
                        this.ordlist1.push(item.goods_name)
                    }
                })
                this.checkChange()
            },
            checkChange() {
                if (this.ordlist.length !== 0) {
                    this.orderlt = []
                    this.ordlist.forEach(item => {
                        this.order.goods_list.forEach(i => {
                            if (item === i.goods_name && i.yuyue_number !== i.goods_number) {
                                this.orderlt.push({'name': i.goods_name, 'num': i.goods_number, 'rec_id': i.rec_id, 'max': +i.goods_number - +i.yuyue_number})
                            }
                        })
                    })
                    // console.log(this.orderlt)
                } else {
                    this.$message.warning('至少选择一种产品')
                }
            },
            consl () {
                this.yytime = Date.parse(this.value1.toLocaleDateString()).toString().slice(0, 10)
                // console.log(this.yytime)
            },
            //订单详情
            OrderDetail(order) {
                localStorage.setItem('temp', JSON.stringify(this.temp))
                localStorage.setItem('isDetail', this.isDetail)
                this.$router.push('/OrderList/' + order.order_sn)
            },
            //取消订单
            cancelOrder(order) {
                this.btnLoading = true;
                cancelOrder(order.order_sn).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已关闭',
                    });
                    this.cancelVisible = false;
                    this.getOrderList()
                    // this.order.status = 1;
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            //移除订单
            deleteOrders (order_sn) {
                deleteOrders(order_sn).then(res => {
                    if (res.data.error === 0) {
                        this.$notify.success({
                            title: '操作成功',
                            message: '该订单已移除',
                        });
                        this.getOrderList()
                    }
                })
            },
            deleteOrder(order, rec_id) {
                this.btnLoading = true;
                // console.log(rec_id);
                deleteOrder(order, rec_id).then((res) => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已删除',
                    });
                    this.cancelVisible = false;
                    this.visible = false;
                    // this.btnLoading = false;
                    this.getOrderList();
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            getAppointment(order_sn) {
                this.getordList()
                getAppointment(order_sn).then(res => {
                    this.addressData = res.data.addres_data;
                    this.appointmentData = res.data.yuyue_data;
                    for (let i = 0, len = res.data.yuyue_data.length; i < len; i++) {
                        if (res.data.yuyue_data[i].remaining > 0) {
                            this.currAppointment = res.data.yuyue_data[i].time;
                            break;
                        }
                    }
                });
            },
            handleSelectAppointment(time) {
                if (this.currAppointment !== time) {
                    this.currAppointment = time;
                }
            },
            open(id) {
                window.open(host + '/flow.php?step=order_pay&id=' + id);
            },
            //设置为支付
            querenOrder (id) {
                this.$alert('是否确认该订单', '确认订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=mendian_confirm&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderList()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            //设置为未支付
            quxiaoOrder (id) {
                this.$alert('是否设置该订单为未支付', '设置订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=change_order_to_unpay&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderList()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            //查看凭证
            checkimg(order) {
                // window.open(host + order.payimg);
                this.order = order
                this.outerVisible = true
            },
            checkFujian (order) {
                // window.open(host + order.payimg);
                this.order = order
                this.showFujian = true
            },
            changeContractNumber (row) {
                this.changeOrderNumber = true
                this.changeForm.contract_number = row.contract_number
                this.changeForm.order_id = row.order_id
            },
            ChangeConOrder() {
                if (this.changeForm.contract_number === '') {
                    this.$message.error('合同订单号不能为空')
                } else {
                    let data = {
                        'session_id': localStorage.getItem('shouhou_session_id'),
                        'order_id': this.changeForm.order_id,
                        contract_number: this.changeForm.contract_number
                    }
                    this.$http.get(this.$reqUrl + 'user.php?act=update_order_address', {params: data}).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('修改成功')
                            this.changeOrderNumber = false
                            this.getOrderList()
                        }
                    })
                }
            },
            imgLook(item) {
                this.pzimg = item
                this.rotate = 0
                this.innerVisible = true
            },
            turnLeft() {
                this.rotate -= 90
            },
            turnRight() {
                this.rotate += 90
            },
            //确认付款
            confirm(order) {
                this.$confirm('确认支付, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'user.php?act=order_confirmPay&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            console.log(res);
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功支付!'
                            });
                        })
                        .catch((res) => {
                            console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消支付',
                    })
                });
            },
            //取消订单
            removes(order) {
                this.$confirm('确认取消订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'user.php?act=cancel_order&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功取消订单!'
                            });
                        })
                        .catch((res) => {
                            // console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作',
                    });
                });
            },
            //添加商品
            addorder(order, goods_id) {
                localStorage.setItem('order_id', order);
                this.$router.push('/SupplyChain/AddProduct');
            },
            in_array(element, a) {
                // console.log(JSON.parse(sessionStorage.getItem('orderAuth')))
                // console.log(element)
                for (var i = 0; i < element.length; i++) {
                    if (element[i] === a) {
                        // console.log("sss")
                        return true;
                    }
                }
                return false;
            },
            //权限设置
            //
            getqx() {
                getUserInfo().then(res => {
                    // console.log(res)
                    // this.orderAuth = res.data.userinfo.orderAuth.split(",");
                    // sessionStorage.setItem('orderAuth',JSON.stringify(this.orderAuth))
                    // console.log(this.orderAuth)
                    // this.orderAuth.forEach((item,i)=>{
                    //     if(item==='payOrder'){
                    //         // console.log('ss')
                    //         this.Auth.payOrder=true
                    //     }
                    //     if(item==='addOrderGoods'){
                    //         this.Auth.addOrderGoods=true
                    //     }
                    //     if(item==='editPay'){
                    //         this.Auth.editPay=true
                    //     }
                    //     if(item==='lookOrder'){
                    //         this.Auth.lookOrder=true
                    //     }
                    //     if(item==='print'){
                    //         this.Auth.print=true
                    //     }
                    //     if(item==='cancelOrder'){
                    //         this.Auth.cancelOrder=true
                    //     }
                    //     if(item==='editOrderGoods'){
                    //         this.Auth.editOrderGoods=true
                    //     }
                    //     if(item==='lirun'){
                    //         this.Auth.lirun=true
                    //     }
                    // })
                    // console.log(this.Auth);
                    // function in_array(element, a) {
                    //     // console.log(element)
                    //     for (var i = 0; i < element.length; i++) {
                    //         if (element[i] === a) {
                    //             console.log("sss")
                    //             return true;
                    //         }
                    //     }
                    //     return false;
                    // }
                    // console.log(in_array(this.orderAuth, 'payOrder'))
                })
            },


            //预约安装弹出框
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            OrderAdd(row) { //弹出框数据赋值
                this.ShowDistribution = true
                this.OrderFenpei = []
                row.goods_list.forEach((item, i) => {
                    if (+item.goods_number - +item.yuyue_number !== 0) {
                        this.OrderFenpei.push(item)
                    }
                    // this.OrderFenpei[i]['max'] = +item.goods_number - +item.yuyue_number
                    // this.OrderFenpei[i]['fpnum'] = +item.goods_number - +item.yuyue_number
                    // if (+item.goods_number - +item.yuyue_number === 0) {}
                })
                // this.OrderFenpei.forEach((item, i) => {
                //     console.log(this.orderFenpei[i].goods_number);
                //     // if (+item.goods_number-+item.yuyue_number ===0){
                //     //     item
                //     // }
                // })
                // console.log(this.OrderFenpei)
                this.form = row
                this.form['time'] = ''
            },
            handleChange() {
                // console.log(this.OrderFenpei)
            },
            //判断配送方式
            isSongZhuang() {
                if (this.formData.goodsSelect !== 3) { //非送装
                    this.formData.azTime = ''
                    this.formData.company_id = ''
                    this.formData.company_name = ''
                } else if (this.formData.goodsSelect === 3) { //送装
                    this.page = 1;
                    getInstallCompany(this.page).then(res => {
                        this.selectCompany = []
                        this.selectCompany = res.data.company_list
                        this.page_count = res.data.page_count
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                getInstallCompany(this.page).then(res => {
                                    res.data.company_list.forEach(item => {
                                        this.selectCompany.push(item)
                                    })
                                })
                            }
                            // console.log(this.selectCompany)
                        }
                    })
                }
                if (this.formData.goodsSelect !== 1) {
                    this.formData.wuliu_id = ''
                    this.formData.wuliu_name = ''
                } else if (this.formData.goodsSelect === 1) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectWuliu = []
                        this.selectWuliu = res.data.data
                        this.page_count = res.data.page_count
                        // console.log(this.selectWuliu)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectWuliu.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
                if (this.formData.goodsSelect !== 0) {
                    this.formData.siji_name = ''
                    this.formData.siji_id = ''
                } else if (this.formData.goodsSelect === 0) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectSonghuo = []
                        this.selectSonghuo = res.data.data
                        this.page_count = res.data.page_count
                        // console.log(this.selectSonghuo)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectSonghuo.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
            },
            selectname(id) { //根据所选安装公司id判断安装公司
                this.selectCompany.forEach((item, i) => {
                    if (id === item.company_id) {
                        this.formData.company_name = item.company_name
                    }
                })
                // console.log(this.formData)
            },
            selectwuliuu(id) { //根据所选物流公司id判断物流公司
                this.selectWuliu.forEach((item, i) => {
                    // console.log(id, item.id)
                    if (id === item.id) {
                        this.formData.wuliu_name = item.name
                    }
                })
                // console.log(this.formData.wuliu_name)
            },
            selectsiji(id) { //根据所选司机id判断司机名
                this.selectSonghuo.forEach((item, i) => {
                    // console.log(item.id)
                    if (id === item.id) {
                        this.formData.siji_name = item.siji_name
                    }
                })
                // console.log(this.formData.siji_name)
            },
            // consl () { //日期转时间戳
            //     this.formData.yytime = Date.parse(this.formData.azTime.toLocaleDateString()).toString().slice(0, 10)
            //     // console.log(this.formData.yytime)
            // },
            handleSelectionChange(val) {
                this.OrderSelect = val;
                // console.log(this.OrderSelect)
            },
            isChangeAddr() { //修改地址
                this.changeAddress = true
            },
            // SureChangeAddr() { //确认修改
            //     this.changeAddress = false
            // },
            FalseChangeAddr() { //取消修改
                this.changeAddress = false
                this.formData.province = this.form.province
                this.formData.city = this.form.city
                this.formData.district = this.form.district
                this.formData.address = this.form.address
                // console.log(this.formData);
            },
            //提交分配
            queren() {
                if (this.OrderSelect.length === 0) {
                    this.$message.error('请选择配送商品')
                } else {
                    let rec_ids = []
                    let numbers = []
                    if (this.changeAddress === false) {
                        this.formData.province = this.form.province
                        this.formData.city = this.form.city
                        this.formData.district = this.form.district
                    }
                    this.OrderSelect.forEach(item => {
                        rec_ids.push(item.rec_id)
                        numbers.push(item.fpnum)
                    })
                    var datas = {
                        city_checked_id: this.formData.city,
                        district_checked_id: this.formData.district,
                        province_checked_id: this.formData.province,
                        address: this.formData.address,
                        mobile: this.form.mobile,
                        consignee: this.form.consignee,
                        order_sn: this.form.order_sn,
                        yuyue_time: this.formData.yytime,
                        rec_ids: rec_ids, //rec_id数组
                        numbers: numbers, //商品数量数组
                        delivery_method: this.formData.goodsSelect,
                        order_id: this.form.order_id,
                        company_id: this.formData.company_id,
                        company_name: this.formData.company_name,
                        wuliu_id: this.formData.wuliu_id,
                        wuliu_name: this.formData.wuliu_name,
                        siji_id: this.formData.siji_id,
                        siji_name: this.formData.siji_name
                    }
                    // console.log(datas)
                    // this.$http.post(this.$reqUrl + `user.php?act=post_orders_yuyue&session_id=${session_id}`, qs.stringify(datas)).then(res => {
                    //     // if (res.data.error === 0) {
                    //     this.$message.success(res.data.msg)
                    //     // this.getOrderList()
                    //     this.ShowDistribution = false
                    //     // }
                    // })
                    postAppointment(datas).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.content)
                            this.getOrderList({page: this.page})
                            this.ShowDistribution = false
                        }
                    })
                }
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0 || rowIndex === 2 || rowIndex === 4 || rowIndex === 6 || rowIndex === 8) {
                    return 'warning-row';
                } else if (rowIndex === 1 || rowIndex === 3 || rowIndex === 5 || rowIndex === 7 || rowIndex === 9) {
                    return 'success-row';
                }
                return '';
            },

        },
    };
</script>
<style lang="less" >
    .wrapper {
        .orderlist-order{
            .el-table .warning-row {
                background: #f9fffc;
            }

            .el-table .success-row {
                background: #e7eef1;
            }
            .el-table th>.cell{
                color:#ea6625;
            }
            .el-table thead.is-group th{
                padding: 0;
            }
            .el-table--enable-row-transition .el-table__body td {
                padding: 0;
            }
            .el-table td, .el-table th {
                padding: 0;
                height: 0;
                line-height: 0;
            }
            .caozuo-btn{
                color: white;
                margin: 4px 4px;
                padding:3px 0;
                float: left;
                width: 45%;
                text-align: center;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/OrderList.vue